// src/pages/clients/anax/Dashboard.js
import React, { useState } from 'react';
import Overview from './components/Overview';
import CompanyProfile from './components/CompanyProfile';
import Assessment from './components/Assessment';
import MarketplaceProcesses from './components/MarketplaceProcesses';
import DealNewsMonitor from './components/DealNewsMonitor';

const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}>
    {children}
  </div>
);

const Tab = ({ active, children, onClick }) => (
  <button
    onClick={onClick}
    className={`
      whitespace-nowrap px-4 py-3 text-sm font-medium border-b-2 
      ${active 
        ? 'border-blue-600 text-blue-600' 
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
      }
    `}
  >
    {children}
  </button>
);

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  
  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Anax Capital Advisory</h1>
              <p className="mt-1 text-sm text-gray-500">AI Implementation Framework - Phase 1</p>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium">Project Start: Nov 2024</p>
                <p className="text-sm text-gray-500">Status: Active</p>
              </div>
              <button className="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700">
                View Progress
              </button>
            </div>
          </div>
        </div>

        {/* Tabs Container */}
        <div className="relative mb-6">
          {/* Shadow Indicators */}
          <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none z-10 md:hidden" />
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none z-10 md:hidden" />
          
          {/* Scrollable Tabs */}
          <div className="overflow-x-auto scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0">
            <div className="border-b border-gray-200 min-w-max">
              <div className="flex -mb-px">
                <Tab 
                  active={activeTab === 'overview'} 
                  onClick={() => setActiveTab('overview')}
                >
                  Overview
                </Tab>
                <Tab 
                  active={activeTab === 'company'} 
                  onClick={() => setActiveTab('company')}
                >
                  Company Profile
                </Tab>
                <Tab 
                  active={activeTab === 'processes'} 
                  onClick={() => setActiveTab('processes')}
                >
                  Business Processes
                </Tab>
                <Tab 
                  active={activeTab === 'dealnews'} 
                  onClick={() => setActiveTab('dealnews')}
                >
                  Deal News
                </Tab>
                <Tab 
                  active={activeTab === 'assessment'} 
                  onClick={() => setActiveTab('assessment')}
                >
                  Assessment
                </Tab>
              </div>
            </div>
          </div>
        </div>

        {/* Content based on active tab */}
        <div className="space-y-6">
          {activeTab === 'overview' && <Overview />}
          {activeTab === 'company' && <CompanyProfile />}
          {activeTab === 'processes' && <MarketplaceProcesses />}
          {activeTab === 'dealnews' && <DealNewsMonitor />}
          {activeTab === 'assessment' && <Assessment />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;